/**
 * Language Switcher Component
 */
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Globe, Check } from 'lucide-react';
import { toast } from 'sonner';

const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸', nativeName: 'English' },
  { code: 'id', name: 'Indonesian', flag: '🇮🇩', nativeName: 'Bahasa Indonesia' },
];

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('pos_language', langCode);
    const langName = languages.find(l => l.code === langCode)?.nativeName || langCode;
    toast.success(t('settings.language.changed', { lang: langName }));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Globe className="h-5 w-5 text-blue-600" />
          {t('settings.language.title')}
        </CardTitle>
        <CardDescription>
          {t('settings.language.description')}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3">
          {languages.map((lang) => (
            <Button
              key={lang.code}
              variant={currentLang === lang.code || currentLang.startsWith(lang.code) ? 'default' : 'outline'}
              className={`justify-start h-auto py-3 px-4 ${
                currentLang === lang.code || currentLang.startsWith(lang.code)
                  ? 'bg-primary text-primary-foreground'
                  : ''
              }`}
              onClick={() => changeLanguage(lang.code)}
              data-testid={`lang-${lang.code}`}
            >
              <span className="text-2xl mr-3">{lang.flag}</span>
              <div className="flex flex-col items-start">
                <span className="font-medium">{lang.nativeName}</span>
                <span className="text-xs opacity-70">{lang.name}</span>
              </div>
              {(currentLang === lang.code || currentLang.startsWith(lang.code)) && (
                <Badge variant="secondary" className="ml-auto">
                  <Check className="h-3 w-3 mr-1" />
                  Active
                </Badge>
              )}
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export default LanguageSwitcher;
